import React, { useEffect, useRef } from "react"
import {
  Button,
  Card,
  CardBody,
  Form,
  Input,
  Label,
  FormFeedback,
} from "reactstrap"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import * as Yup from "yup"
import { useFormik } from "formik"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from "react-toastify"
import {
  getBazaarDetails,
  editBazaar,
  fetchBazaarList,
  fetchAddOnItemList,
} from "../../../redux/actions/pvs"
import {
  GET_BAZAAR_DETAILS_RESET,
  EDIT_BAZAAR_RESET,
} from "../../../redux/types/pvs"
import PageLoader from "components/Common/PageLoader"

const EditBazaar = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const [filteredBazaarList, setFilteredBazaarList] = React.useState([])
  const [addOns, setAddOns] = React.useState([])
  const addOnsRef = useRef([])

  const getBazaarDetailScreen = useSelector(
    state => state.screens.pvs.getBazaarDetail
  )
  const editBazaarScreen = useSelector(state => state.screens.pvs.editBazaar)
  const bazaarList = useSelector(state => state.pvs.bazaarList)
  const addOnItemList = useSelector(state => state.pvs.addOnItemList)
  const token = useSelector(state => state.auth.token)

  const encBazaarId = new URLSearchParams(location.search).get("id")

  useEffect(() => {
    addOnsRef.current = addOns
  }, [addOns])

  // Fetch bazaar detail and group list on mount
  useEffect(() => {
    dispatch(fetchBazaarList({ offset: 1 }, token))
    dispatch(fetchAddOnItemList())
    if (encBazaarId) {
      dispatch(getBazaarDetails(encBazaarId))
    }
    return () => {
      dispatch({ type: GET_BAZAAR_DETAILS_RESET })
    }
  }, [encBazaarId])

  useEffect(() => {

    if (
      bazaarList &&
      bazaarList.length > 0 &&
      getBazaarDetailScreen.success &&
      getBazaarDetailScreen.data
    ) {
      let tempBazaarList = []

      bazaarList.forEach(bazaar => {
        if (bazaar.bazaar_name !== getBazaarDetailScreen.data.bazaar_name) {
          tempBazaarList.push({
            label: bazaar.bazaar_name,
            value: bazaar.enc_bazaar_id,
            enc_combine_group_id: bazaar.enc_combine_group_id,
            combine_group_id: bazaar.combine_group_id,
          })
        }
      })

      let selectedBazaar = tempBazaarList.find(
        bazaar =>
          bazaar.combine_group_id ===
          getBazaarDetailScreen.data.combine_group_id
      )

      console.log("selectedBazaar..", selectedBazaar)
      // formik.setFieldValue("group_bazaar", selectedBazaar)
      const d = getBazaarDetailScreen.data
      let formikData = {
        bazaar_name: d.bazaar_name || "",
        location: d.location || "",
        start_date: d.start_date ? new Date(d.start_date) : "",
        end_date: d.end_date ? new Date(d.end_date) : "",
        booking_date: d.booking_date ? new Date(d.booking_date) : "",
        description: d.description || "",
        interakt_template_id: d.interakt_template_id || "",
        group_bazaar: selectedBazaar,
      }
      formik.setValues(formikData)
      setFilteredBazaarList(tempBazaarList)
      setAddOns(
        (d.add_ons || d.add_on || []).map(item => {
          const itemId = item.item_id || item.stall_add_on_id || resolveAddonId(item)
          const matched = addOnItemList.find(opt => (opt.item_id || opt.id) == itemId)
          return {
            item_id: itemId,
            item_name: (matched && (matched.item_name || matched.name)) || item.item_name || item.name || "",
            item_cost: item.item_total_cost || 0,
          }
        })
      )
    }
  }, [bazaarList, getBazaarDetailScreen.success, getBazaarDetailScreen.data])

  // Populate form when detail loads
  // useEffect(() => {
  //   if (getBazaarDetailScreen.success && getBazaarDetailScreen.data) {
  //     const d = getBazaarDetailScreen.data
  //     console.log('bazaar details..', d);
  //     console.log('filteredBazaarList..', filteredBazaarList);

  //     let selectedBazaar = filteredBazaarList.find(
  //       bazaar => bazaar.combine_group_id === d.combine_group_id
  //     )

  //     let formikData = {
  //       bazaar_name: d.bazaar_name || "",
  //       location: d.location || "",
  //       start_date: d.start_date ? new Date(d.start_date) : "",
  //       end_date: d.end_date ? new Date(d.end_date) : "",
  //       booking_date: d.booking_date ? new Date(d.booking_date) : "",
  //       description: d.description || "",
  //       group_bazaar: selectedBazaar,
  //     }
  //     formik.setValues(formikData)
  //   }
  // }, [getBazaarDetailScreen.success])

  // Watch edit bazaar result
  useEffect(() => {
    if (editBazaarScreen.success) {
      toast.success(editBazaarScreen.message)
      dispatch({ type: EDIT_BAZAAR_RESET })
      navigate(-1)
    }
    if (editBazaarScreen.error) {
      toast.error(editBazaarScreen.error)
      dispatch({ type: EDIT_BAZAAR_RESET })
    }
  }, [editBazaarScreen])

  const resolveAddonId = opt => {
    const idFields = ["item_id", "id", "add_on_id", "stall_add_on_id", "enc_add_on_id", "enc_item_id", "value"]
    for (let i = 0; i < idFields.length; i++) {
      const v = opt[idFields[i]]
      if (v !== null && v !== undefined) return v
    }
    const nameVal = opt.item_name || opt.name || opt.label || ""
    const keys = Object.keys(opt)
    for (let i = 0; i < keys.length; i++) {
      const v = opt[keys[i]]
      if (v !== null && v !== undefined && typeof v !== "object" && v !== nameVal) return v
    }
    return null
  }

  const handleAddOnSelect = (index, option) => {
    const updated = [...addOns]
    updated[index] = Object.assign({}, updated[index], {
      item_id: option ? option.value : null,
      item_name: option ? option.label : "",
    })
    setAddOns(updated)
  }

  const handleAddOnChange = (index, field, value) => {
    const updated = [...addOns]
    updated[index] = Object.assign({}, updated[index], { [field]: value })
    setAddOns(updated)
  }

  const handleAddOnAdd = () => {
    setAddOns([...addOns, { item_id: undefined, item_name: "", item_cost: "" }])
  }

  const handleAddOnRemove = index => {
    const updated = [...addOns]
    updated.splice(index, 1)
    setAddOns(updated)
  }

  const formik = useFormik({
    initialValues: {
      bazaar_name: "",
      location: "",
      start_date: "",
      end_date: "",
      booking_date: "",
      description: "",
      interakt_template_id: "",
      group_bazaar: "",
    },

    validationSchema: Yup.object({
      bazaar_name: Yup.string().required("Bazaar name is required"),
      location: Yup.string().required("Location is required"),
      group_bazaar: Yup.mixed().required("Group Bazaar is required"),
      start_date: Yup.date()
        .required("Start date is required")
        .typeError("Start date is required"),
      end_date: Yup.date()
        .required("End date is required")
        .typeError("End date is required")
        .min(Yup.ref("start_date"), "End date must be after start date"),
      booking_date: Yup.date()
        .required("Booking date is required")
        .typeError("Booking date is required"),
      description: Yup.string().required("Description is required"),
    }),

    onSubmit: values => {
      const requestBody = {
        enc_bazaar_id: encBazaarId,
        bazaar_name: values.bazaar_name,
        start_date: moment(values.start_date.toString()).format("YYYY-MM-DD"),
        end_date: moment(values.end_date.toString()).format("YYYY-MM-DD"),
        booking_date: moment(values.booking_date.toString()).format(
          "YYYY-MM-DD"
        ),
        location: values.location,
        description: values.description,
        interakt_template_id: values.interakt_template_id,
        enc_combine_bazaar_id: values.group_bazaar.value,
        add_ons: addOnsRef.current
          .filter(item => item.item_id !== null && item.item_id !== undefined)
          .map(item => ({
            item_id: item.item_id,
            item_total_cost: Number(item.item_cost) || 0,
          })),
      }
      dispatch(editBazaar(requestBody))
    },
  })

  document.title = "Edit Bazaar | PULA"
  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between mb-3"></div>

        <Form
          className="mt-4"
          onSubmit={e => {
            e.preventDefault()
            formik.handleSubmit()
            return false
          }}
          action="#"
        >
          {/* Bazaar Details */}
          <Card>
            <CardBody>
              <div>
                <h4 className="font-size-18 mb-3 mt-3">Bazaar Details</h4>
                <div className="border-top mt-3 pb-4 mb-1"></div>
                <Form>
                  <div className="row">
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="bazaar_name">
                          Bazaar Name&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="bazaar_name"
                          className="form-control"
                          placeholder="Enter Bazaar Name"
                          type="text"
                          id="bazaar_name"
                          onChange={formik.handleChange}
                          value={formik.values.bazaar_name}
                          invalid={
                            formik.touched.bazaar_name &&
                            formik.errors.bazaar_name
                              ? true
                              : false
                          }
                        />
                        {formik.touched.bazaar_name &&
                        formik.errors.bazaar_name ? (
                          <FormFeedback type="invalid">
                            {formik.errors.bazaar_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="location">
                          Location&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="location"
                          className="form-control"
                          placeholder="Enter Location"
                          type="text"
                          id="location"
                          onChange={formik.handleChange}
                          value={formik.values.location}
                          invalid={
                            formik.touched.location && formik.errors.location
                              ? true
                              : false
                          }
                        />
                        {formik.touched.location && formik.errors.location ? (
                          <FormFeedback type="invalid">
                            {formik.errors.location}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-sm-6 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="group_bazaar">
                          Group Bazaar&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="group_bazaar"
                          placeholder="Select Group Bazaar"
                          options={filteredBazaarList}
                          value={
                            formik.values.group_bazaar
                              ? filteredBazaarList.find(
                                  opt =>
                                    opt.combine_group_id ===
                                    formik.values.group_bazaar.combine_group_id
                                )
                              : null
                          }
                          onChange={option =>
                            formik.setFieldValue("group_bazaar", option)
                          }
                          classNamePrefix="select"
                        />
                        {formik.touched.group_bazaar &&
                        formik.errors.group_bazaar ? (
                          <div className="text-danger font-size-12 mt-1">
                            {formik.errors.group_bazaar}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {/* START DATE */}
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="start_date">
                          Start Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Flatpickr
                          id="start_date"
                          className={`form-control d-block ${
                            formik.touched.start_date &&
                            formik.errors.start_date
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="MM DD, YYYY"
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                          value={formik.values.start_date}
                          onChange={date =>
                            formik.setFieldValue("start_date", date[0])
                          }
                          onClose={() =>
                            formik.setFieldTouched("start_date", true)
                          }
                        />
                        {formik.touched.start_date &&
                        formik.errors.start_date ? (
                          <FormFeedback className="d-block" type="invalid">
                            {formik.errors.start_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* END DATE */}
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="end_date">
                          End Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Flatpickr
                          id="end_date"
                          className={`form-control d-block ${
                            formik.touched.end_date && formik.errors.end_date
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="MM DD, YYYY"
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                          value={formik.values.end_date}
                          onChange={date =>
                            formik.setFieldValue("end_date", date[0])
                          }
                          onClose={() =>
                            formik.setFieldTouched("end_date", true)
                          }
                        />
                        {formik.touched.end_date && formik.errors.end_date ? (
                          <FormFeedback className="d-block" type="invalid">
                            {formik.errors.end_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* BOOKING DATE */}
                    <div className="col-12 col-sm-4 mb-3">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="booking_date">
                          Booking Date&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <Flatpickr
                          id="booking_date"
                          className={`form-control d-block ${
                            formik.touched.booking_date &&
                            formik.errors.booking_date
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="MM DD, YYYY"
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                          value={formik.values.booking_date}
                          onChange={date =>
                            formik.setFieldValue("booking_date", date[0])
                          }
                          onClose={() =>
                            formik.setFieldTouched("booking_date", true)
                          }
                        />
                        {formik.touched.booking_date &&
                        formik.errors.booking_date ? (
                          <FormFeedback className="d-block" type="invalid">
                            {formik.errors.booking_date}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="description">
                          Description&nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                        <textarea
                          name="description"
                          id="description"
                          className={`form-control ${
                            formik.touched.description &&
                            formik.errors.description
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="5"
                          placeholder="Enter Description"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.description}
                        />
                        {formik.touched.description &&
                        formik.errors.description ? (
                          <FormFeedback type="invalid">
                            {formik.errors.description}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <Label
                          className="form-label"
                          htmlFor="interakt_template_id"
                        >
                          Interakt Template ID
                        </Label>
                        <Input
                          name="interakt_template_id"
                          id="interakt_template_id"
                          type="text"
                          placeholder="Paste the template ID from the Interakt dashboard"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.interakt_template_id || ""}
                        />
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </CardBody>
          </Card>

          {/* Add-Ons */}
          <Card>
            <CardBody>
              <div className="row">
                <div className="col-12 col-sm-6">
                  <h4 className="nom-title">Add-Ons</h4>
                </div>
                <div className="col-12 col-sm-6 d-flex justify-content-end align-items-center">
                  <Button
                    onClick={handleAddOnAdd}
                    type="button"
                    color="primary"
                    size="md"
                    className="mt-3 mt-lg-0"
                  >
                    Add Items +
                  </Button>
                </div>
              </div>
              <div className="border-top pb-4 mb-1"></div>
              {addOns.length === 0 && (
                <p className="text-muted">No add-ons added yet.</p>
              )}
              {addOns.map((item, index) => {
                const addonOptions = addOnItemList.map(opt => ({
                  value: resolveAddonId(opt),
                  label: opt.item_name || opt.name || "",
                }))
                const selectedAddon = addonOptions.find(opt => opt.value == item.item_id) || null
                return (
                  <div key={index} className="row align-items-end mb-2">
                    <div className="mb-3 col-12 col-sm-5 col-lg-4">
                      <Label className="form-label">Item Name</Label>
                      <Select
                        placeholder="Select Item"
                        options={addonOptions}
                        value={selectedAddon}
                        onChange={option => handleAddOnSelect(index, option)}
                        classNamePrefix="select"
                      />
                    </div>
                    <div className="mb-3 col-12 col-sm-5 col-lg-4">
                      <Label className="form-label">Item Cost</Label>
                      <Input
                        type="number"
                        placeholder="Enter Item Cost"
                        value={item.item_cost}
                        onChange={e =>
                          handleAddOnChange(index, "item_cost", e.target.value)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-12 col-sm-2 col-lg-1 mb-3 pb-1">
                      <Button
                        onClick={() => handleAddOnRemove(index)}
                        type="button"
                        size="sm"
                        color="danger"
                      >
                        <i className="mdi mdi-delete"></i>
                      </Button>
                    </div>
                  </div>
                )
              })}
            </CardBody>
          </Card>

          <div className="d-flex justify-content-center mt-4">
            <Button
              type="submit"
              color="primary"
              className="w-20 btn btn-block font-size-16 mt-3"
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
      <PageLoader
        open={getBazaarDetailScreen.loading || editBazaarScreen.loading}
      />
    </div>
  )
}

export default EditBazaar
